import React from "react";
import { RentReportingInfoScreenContainer } from "src/containers";

export const RentReportingInfoScreen = () => {
  return <RentReportingInfoScreenContainer />;
};
